import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Badge, ToggleButton, ToggleButtonGroup } from '@mui/material'
import classNames from 'classnames'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './ProductFilterSize.module.scss'
import { ProductSizeInterface } from '../../../interfaces/ProductInterface'
import { FILTER_FLAT } from '../../../utils/productFilter'
import { _at } from '../../../utils/translations'
import ProductFilterActiveCount from '../ProductFilterActiveCount/ProductFilterActiveCount'

interface Props {
  selectedValues: string[]
  sizes: ProductSizeInterface[]
  onSelectionChange: (name: string, valueId: number | string, checked: boolean) => void
}

const ProductFilterSize: React.FC<Props> = (props: Props) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(props.selectedValues)

  useEffect(() => {
    setSelectedValues(props.selectedValues)
  }, [JSON.stringify(props.selectedValues)])

  const handleButtonClick = (sizeKey: string) => {
    const checked = !selectedValues.includes(sizeKey)
    let newSelectedValues = [...selectedValues]
    if (checked) {
      newSelectedValues.push(sizeKey)
    } else {
      newSelectedValues = selectedValues.filter(value => value !== sizeKey)
    }
    setSelectedValues(newSelectedValues)
    props.onSelectionChange(FILTER_FLAT.SIZES, sizeKey, checked)
  }

  const options = props.sizes.map(size => {
    return (
      <ToggleButton
        key={`product-filter-size-value-${size.id}`}
        value={size.sizeKey}
        classes={{
          root: classNames(styles['toggle-button-group__button']),
          selected: styles['toggle-button-group__button--selected'],
        }}
        onChange={() => {
          handleButtonClick(size.sizeKey)
        }}
      >
        <div className={styles['toggle-button-group__button__label']}>{size.label}</div>
      </ToggleButton>
    )
  })

  return (
    <Accordion elevation={0} classes={{ root: styles['product-filter-size__accordion'] }}>
      <AccordionSummary
        classes={{
          root: styles['accordion_summary__root'],
          content: styles['accordion_summary__content'],
          expanded: styles['accordion_summary__content--expanded'],
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <FormattedMessage id="ProductFilter.Size" defaultMessage="Size" />
        {selectedValues.length ? <ProductFilterActiveCount count={selectedValues.length} /> : null}
      </AccordionSummary>
      <AccordionDetails>
        <ToggleButtonGroup value={selectedValues} classes={{ root: styles['product-filter-size__toggle-button-group'] }}>
          {options}
        </ToggleButtonGroup>
      </AccordionDetails>
    </Accordion>
  )
}

export default ProductFilterSize
